import styled from '@emotion/styled';

export const GhostContentContainer = styled.div`
  margin: auto;
  max-width: ${({ theme }) => theme.maxWidth.lg};
  background: ${({ theme }) => theme.colors.secondary.white};
  padding: 2rem;
  font-size: 1.07rem;
  line-height: 1.7rem;
  margin-top: -80px;
  word-break: break-word;
  img {
    max-width: 100%;
    height: auto;
  }
  blockquote {
    position: relative;
    padding-left: 1em;
    border-left: 0.2em solid ${({ theme }) => theme.colors.primary.orange};
    font-style: italic;
    margin: 0;
    color: ${({ theme }) => theme.colors.secondary.graphite};
  }
  h2 {
    margin: 2.5rem 0 1.3rem 0;
    line-height: 2.6rem;
    cursor: pointer;
  }
  p:first-child,
  h2:first-child,
  h3:first-child {
    margin-top: 0;
    line-height: 2rem;
  }
  h3 {
    margin: 2rem 0 1rem 0;
    cursor: pointer;
  }
  blockquote code,
  p code,
  h1 code,
  h2 code,
  h3 code,
  h4 code,
  h5 code,
  ol code,
  ul code {
    padding: 3px 8px;
    font-size: 0.8em;
    background: ${({ theme }) => theme.colors.secondary.darkPaleGray};
    border-radius: 3px;
  }
  blockquote code {
    font-style: normal;
    color: ${({ theme }) => theme.colors.secondary.black};
  }
  figure[class~='kg-embed-card'] {
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
    margin: 0;
  }
  figure[class~='kg-embed-card'] iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
  figure[class~='kg-image-card'] {
    margin: 0;
  }
  table {
    border: 1px solid ${({ theme }) => theme.colors.secondary.lightGray};
    border-collapse: collapse;
    display: block;
    max-width: -moz-fit-content;
    max-width: fit-content;
    overflow-x: auto;
    white-space: nowrap;
    margin: 10px 0;
  }
  table th,
  table td {
    border: 1px solid ${({ theme }) => theme.colors.secondary.lightGray};
    padding: 10px;
  }
  table tr:nth-of-type(even) {
    background-color: ${({ theme }) => theme.colors.secondary.paleGray};
  }
  table tr:hover {
    background-color: ${({ theme }) => theme.colors.secondary.lightGray};
  }
  table th {
    padding: 12px;
    text-align: left;
    background-color: ${({ theme }) => theme.colors.secondary.gray};
    color: ${({ theme }) => theme.colors.secondary.white};
  }
  ${({ theme }) => theme.breakpoints.md} {
    padding: 0.9rem;
    margin-top: -50px;
  }
  pre {
    overflow-y: auto;
    max-width: calc(100vw - 40px);
  }
`;
